import PropTypes from 'prop-types';
export const UNINITIALIZED = 'UNINITIALIZED';
export const PENDING = 'PENDING';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const QUEUED = 'QUEUED';
export const FINISHED = 'FINISHED';
export const RequestStatusProp = PropTypes.oneOf([UNINITIALIZED, PENDING, SUCCEEDED, FAILED, QUEUED, FINISHED]);